export function getApiOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

export function getCalendarFeedUrl(token) {
  return `${getApiOrigin()}/api/calendar/feed/${token}`;
}

export function getWebcalUrl(httpsUrl) {
  return httpsUrl.replace(/^https?:\/\//, "webcal://");
}

/** Abonnement Google Agenda via URL HTTPS (Android + desktop). */
export function getGoogleCalendarAddByUrl(httpsFeedUrl) {
  return `https://calendar.google.com/calendar/u/0/r/settings/addbyurl?url=${encodeURIComponent(httpsFeedUrl)}`;
}

/** Ouverture Google Agenda avec cid webcal (certaines apps Android). */
export function getGoogleCalendarSubscribeUrl(httpsUrl) {
  const webcal = getWebcalUrl(httpsUrl);
  return `https://www.google.com/calendar/render?cid=${encodeURIComponent(webcal)}`;
}

export function detectPlatform() {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
}

export function isMobilePlatform() {
  return detectPlatform() !== "desktop";
}